var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.572,
    height: 17.518,
    viewBox: "0 0 17.572 17.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-male",
    "data-name": "Icon metro-male",
    d: "M16.753,7.716h7.182l-.016,7.262-2.463-2.461-2.321,2.321a6.323,6.323,0,1,1-2.2-2.269l2.3-2.326L16.753,7.716Zm-6.24,10.223a3.148,3.148,0,1,0,3.148-3.148A3.148,3.148,0,0,0,10.513,17.939Z",
    transform: "translate(-6.864 -7.216)",
    fill: "#a1a3ef",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/maleIcon.bb5ec6dd8c93a6983aecc78be2483ce3.svg";
export { ForwardRef as ReactComponent };